<template>
<div>
    <question-list-card
        v-for="(question, index) of sortedQuestions"
        :key="index"
        :row-number="index + 1"
        :question="question"
    />
</div>
</template>

<script>
import {mapGetters} from "vuex";
import QuestionListCard from "./QuestionListCard";

export default {
    name: "QuestionList",
    components: {QuestionListCard},
    computed: {
        ...mapGetters('tests', [
            'testBeingEdited',
        ]),
        questions() {
            return this.testBeingEdited.questions ?? [];
        },
        sortedQuestions() {
            let result = [];

            for (let [key, value] of Object.entries(this.questions)) {
                result.push(value);
            }

            return result.sort((a,b) => {
                return  a.sort < b.sort ? -1 : 1;
            })
        }
    },
    methods: {
        getRowNumber(questionId) {
            let keys = Object.keys(this.questions);

            return keys.indexOf(questionId) + 1;
        }
    }
}
</script>

<style>
.test-question-card {
    margin-bottom: 10px;
}
</style>
